import { generateServiceId } from "@core/domains/identity";

export const ADMIN_SERVICE = {
  ID: generateServiceId("admin"),
  JOB_TYPES: { tableSync: "tableSync" },
  LABEL: "admin",
} as const;
